var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('Loader'):_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Incomplete size conversions")]),_c('Table',{staticClass:"margin-top",attrs:{"filters":_vm.filters,"columns":_vm.columns,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }